export enum ClientDonorStatus {
  Active = 1,
  DoNotContact = 2,
  Archived = 3
}
